import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { ToastService } from '../toast.service';
import { AuthService } from '../auth.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const toast = inject(ToastService);
  const auth = inject(AuthService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      console.log('HTTP Error:', error.status, error.message, error.url);

      if (error.status === 401) {
        const authEndpoints = ['/auth/login', '/auth/register', '/auth/sms', '/auth/changePassword'];
        const isAuthEndpoint = authEndpoints.some(path => error.url?.includes(path));
        const hasExistingSession = !!auth.token;
        const isAlreadyOnLogin = router.url === '/' || router.url === '';

        if (!isAuthEndpoint && hasExistingSession && !isAlreadyOnLogin) {
          auth.token = '';
          router.navigateByUrl('/');
        }
      }

      if (error.status === 500) {
        toast.presentWarningToast('Serverfehler. Bitte versuchen Sie es erneut.');
      }

      return throwError(() => error);
    }),
  );
};
